import React, { useEffect, useState } from "react";
import AbhaCardUI from "../pages/Abha-card/abha-card-ui";
import { Modal, Input, message } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { setResentCount } from "../redux/slices/abhaSlice";
import VerifyNumberAbha from "../pages/abhanumber-details/verify-number-abha";
import { SendAadharOtp } from "../services";

const ComparisonScreen = ({ downloadFlowToken, selectedAbhaCard }) => {
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [userData, setUserData] = useState(null);
  const [showCard, setShowCard] = useState(false);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [mobile, setMobile] = useState("");

  const [verifyNumberAbha, setVerifyNumberAbha] = useState(false);
  const [resMessage, setResMessage] = useState("");
  const resendCount = useSelector((state) => state.user.resentCount);
  const dispatch = useDispatch();

  useEffect(() => {
    const selected = localStorage.getItem("selectedIndex");
    const user = localStorage.getItem("userData");

    if (selected) setSelectedIndex(JSON.parse(selected));
    if (user) {
      const parsed = JSON.parse(user);
      setUserData(parsed);
    }
  }, []);

  // if (!selectedIndex || !userData) {
  //   return <div className="p-4 text-center">No comparison data found</div>;
  // }

  if (showCard) {
    return <AbhaCardUI downloadFlowToken={downloadFlowToken} />;
  }
  const displayData =
    userData?.accounts?.find(
      (acc) =>
        acc.name === selectedAbhaCard.name &&
        acc.ABHANumber?.split("-")[3] ===
          selectedAbhaCard.ABHANumber?.split("-")[3]
    ) || {};

  const account = displayData || userData || {};
  const normalizeData = (data = {}) => (
    {
      fullName: data?.fullname || data?.fullName || data?.name || "",
      dob: data?.dob || data?.abhaDob || "",
      gender: data?.gender || data?.abhaGender || "",
      abhaNumber:
        data?.healthIdNumber || data?.abhaNumber || data?.ABHANumber || "",
      abhaAddress: data?.abhaAddress || data?.preferredAbhaAddress || "",
      mobile: data?.mobileNo || data?.mobile || ""
    }
  );

  const leftData = normalizeData(selectedIndex);
  const rightData = normalizeData(account);
  // console.log("rightData", rightData);

  const comparisonFields = [
    { label: "Full Name", left: leftData.fullName, right: rightData.fullName },
    {
      label: "DOB",
      left: leftData.dob,
      right: rightData.dob
    },
    {
      label: "Gender",
      left: leftData.gender,
      right: rightData.gender === "M" ? "Male" : "Female"
    },
    // { label: "Mobile No", left: leftData.mobile, right: rightData.mobile },
    {
      label: "ABHA Number",
      left: leftData.abhaNumber,
      right: rightData.abhaNumber
    },
    {
      label: "ABHA Address",
      left: leftData.abhaAddress,
      right: rightData.abhaAddress
    }
  ];

  const handleSendOtp = async () => {
    if (!mobile) {
      message.warning("Please enter a mobile number");
      return;
    }
    try {
      const res = await SendAadharOtp({
        headers: {},
        data: { mobile }
      });

      if (res?.txnId) {
        message.success("OTP sent successfully");

        localStorage.setItem("txnId", res.txnId);
        localStorage.setItem("mobile", mobile);

        if (res?.resent_count !== undefined) {
          dispatch(setResentCount(res.resent_count));
        }

        setIsModalOpen(false);
        setVerifyNumberAbha(true);
        setResMessage(res.message);
      } else {
        message.error(res?.message || "Failed to send OTP");
      }
    } catch (err) {
      console.error(err);
      message.error("Something went wrong while sending OTP");
    }
  };

  return (
    <>
      {verifyNumberAbha ? (
        <VerifyNumberAbha
          handleBack={() => setVerifyNumberAbha(false)}
          inputType="mobile"
          inputValue={mobile}
          otpType="abdm"
          initialResentCount={resendCount}
          setResMessage={setResMessage}
          resMessage={resMessage}
        />
      ) : (
        <div
          style={{
            marginLeft: "50px",
            backgroundColor: "#20405F",
            color: "white",
            padding: "20px",
            borderRadius: "10px"
          }}
        >
          <h2 className="text-2xl font-bold text-center mb-6 ">
            Comparison Screen
          </h2>

          <div className="overflow-x-auto">
            <table className="min-w-full border border-gray-300 bg-white text-black">
              <thead>
                <tr className="bg-gray-200 text-left">
                  <th className="border px-4 py-2">Field</th>
                  <th className="border px-4 py-2">HIMS Data</th>
                  <th className="border px-4 py-2">ABDM Data</th>
                  <th className="border px-4 py-2">Value Matched</th>
                </tr>
              </thead>
              <tbody>
                {comparisonFields.map((row, idx) => {
                  const isDifferent = row.left !== row.right;
                  return (
                    <tr key={idx} className={isDifferent ? "bg-red-100" : ""}>
                      <td className="border px-4 py-2 font-semibold">
                        {row.label}
                      </td>
                      <td className="border px-4 py-2">{row.left || "-"}</td>
                      <td
                        className="border px-4 py-2"
                        style={{ color: isDifferent ? "red" : "green" }}
                      >
                        {row.right || "-"}
                      </td>
                      <td
                        className="border px-4 py-2"
                        style={{ color: isDifferent ? "red" : "green" }}
                      >
                        {isDifferent ? "No" : "Yes"}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>

          <div
            className="mt-10 flex justify-center items-center gap-20"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: "20px",
              marginTop: "40px",
              marginBottom: "20px"
            }}
          >
            <button
              onClick={() => setShowCard(true)}
              style={{ backgroundColor: "#f59e0b" }}
              className=" text-white px-4 py-2 rounded"
            >
              Continue
            </button>

            <button
              onClick={() => window.location.reload()}
              className="text-black px-4 py-2 rounded"
            >
              Cancel
            </button>
          </div>

          <Modal
            title="Enter Mobile Number"
            open={isModalOpen}
            onCancel={() => setIsModalOpen(false)}
            onOk={handleSendOtp}
            okText="Continue"
          >
            <Input
              value={mobile}
              onChange={(e) => setMobile(e.target.value)}
              placeholder="Enter mobile number"
              autoComplete="off"
              maxLength={10}
            />
          </Modal>
        </div>
      )}
    </>
  );
};

export default ComparisonScreen;
